/*
 * @Author: your name
 * @Date: 2021-08-26 16:11:59
 * @LastEditTime: 2021-08-26 16:24:42
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \front-questionnaire\src\router\account.ts
 */
import { RouteConfig } from 'vue-router';
import PView from '../layouts/view.vue';

const accountRoute: RouteConfig[] = [
  {
    path: '/account',
    component: PView,
    meta: { title: '账户资料' },
    redirect: '/info.html',
    children: [
      {
        path: '/info.html',
        name: 'account',
        component: () => import('@/views/system/account/index.vue'),
        meta: { title: '用户账户资料', parentTab: 'account' },
      },
    ],
  },
  {
    path: '/bindingServicer',
    component: PView,
    meta: { title: '绑定服务号' },
    redirect: '/bindingServicer/index.html',
    children: [
      {
        path: '/bindingServicer/index.html',
        name: 'bindingServicer',
        component: () => import('@/views/system/account/bindingServicer.vue'),
        meta: { title: '绑定服务号', parentTab: 'account' },
      },
    ],
  },
  {
    path: '/accountRecharge',
    component: PView,
    meta: { title: '充值' },
    redirect: '/accountRecharge/index.html',
    children: [
      {
        path: '/accountRecharge/index.html',
        name: 'accountRecharge',
        component: () => import('@/views/system/account/accountRecharge.vue'),
        meta: { title: '充值', parentTab: 'account' },
      },
    ],
  },
  {
    path: '/transactionsRecord',
    component: PView,
    meta: { title: '充值记录' },
    redirect: '/transactionsRecord/index.html',
    children: [
      {
        path: '/transactionsRecord/index.html',
        name: 'transactionsRecord',
        component: () => import('@/views/system/account/transactionsRecord.vue'),
        meta: { title: '充值记录', parentTab: 'account' },
      },
    ],
  },
  {
    path: '/smsSign',
    component: PView,
    meta: { title: '短信签名' },
    redirect: '/smsSign/index.html',
    children: [
      {
        path: '/smsSign/index.html',
        name: 'smsSign',
        component: () => import('@/views/system/account/smsSign.vue'),
        meta: { title: '短信签名', parentTab: 'account' },
      },
    ],
  },
  {
    path: '/buyAI',
    component: PView,
    meta: { title: 'AI充值' },
    redirect: '/buyAI.html',
    children: [
      {
        path: '/buyAI.html',
        name: 'accountBuyAI',
        component: () => import('@/views/system/account/buyAIAccound..vue'),
        meta: { title: 'AI充值', parentTab: 'account' },
      },
    ],
  },
  {
    path: '/buySmsAccound',
    component: PView,
    meta: { title: '购买短信' },
    redirect: '/buySmsAccound.html',
    children: [
      {
        path: '/buySmsAccound.html',
        name: 'buySmsAccound',
        component: () => import('@/views/system/account/buySmsAccound.vue'),
        meta: { title: '购买短信', parentTab: 'account' },
      },
    ],
  },
  {
    path: '/buyAdvAccound',
    component: PView,
    meta: { title: '购买广告额度' },
    redirect: '/buyAdvAccound.html',
    children: [
      {
        path: '/buyAdvAccound.html',
        name: 'buyAdvAccound',
        component: () => import('@/views/system/account/buyAdvAccound.vue'),
        meta: { title: '购买广告额度', parentTab: 'account' },
      },
    ],
  },
  {
    path: '/buyRiskAccound',
    component: PView,
    meta: { title: '购买风控额度' },
    redirect: '/buyRiskAccound.html',
    children: [
      {
        path: '/buyRiskAccound.html',
        name: 'buyRiskAccound',
        component: () => import('@/views/system/account/buyRiskAccound.vue'),
        meta: { title: '购买风控额度', parentTab: 'account' },
      },
    ],
  },
];

export { accountRoute };
